import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import formRules from './formRules';
import ErrorComponent from '../../components/Error';
import {
  injectFormState,
  onChangeFieldText,
  onBlurFieldText,
  formValidate,
} from '../../utils/form';
// translate
import messages from './messages';

class Forgot extends Component {
  constructor(props) {
    super(props);

    const attributes = {
      email: '',
    };

    this.state = Object.assign(
      {
        attributes,
      },
      injectFormState(formRules, attributes),
    );

    this.formValidate = formValidate.bind(this);
    this.onChangeFieldText = onChangeFieldText.bind(this);
    this.onBlurFieldText = onBlurFieldText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.formValidate(this.state.attributes).then((data) => {
      if (data.status) {
        this.props.onForgotClick(this.state.attributes);
      }
    });
  }

  renderForm() {
    const { intl, isFetching } = this.props;
    const { validation } = this.state.formSchema;

    return (
      <form className="popup-form" method="post">
        <label className="label" htmlFor="email">
          {validation.email.message &&
            <span className="popup-form-error">
              {intl.formatMessage(validation.email.message)}
            </span>}
          <input
            type="text"
            name="email"
            data-validation-onchange={false}
            placeholder={intl.formatMessage(messages.placeholderEmail)}
            onChange={this.onChangeFieldText}
            onBlur={this.onBlurFieldText}
          />
        </label>

        <button
          className="trans"
          type="button"
          disabled={isFetching}
          onClick={this.onSubmit}
        >
          {intl.formatMessage(messages.forgotButton)}
        </button>
      </form>
    );
  }

  render() {
    const { forgotErrorMessage, forgotSuccess, isFetching } = this.props;
    const { email } = this.state.attributes;

    return (
      <div>
        {!forgotSuccess && this.renderForm()}
        {forgotSuccess &&
          <div className="popup-form-success">
            <FormattedHTMLMessage
              {...Object.assign(messages.successText, {
                values: { email },
              })}
            />
          </div>}
        {forgotErrorMessage &&
          !isFetching &&
          <ErrorComponent>{forgotErrorMessage}</ErrorComponent>}
      </div>
    );
  }
}

Forgot.propTypes = {
  intl: intlShape.isRequired,
  onForgotClick: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  forgotErrorMessage: PropTypes.any,
  forgotSuccess: PropTypes.bool.isRequired,
};

Forgot.defaultProps = {
  forgotErrorMessage: false,
};

export default injectIntl(Forgot);



// WEBPACK FOOTER //
// ./src/components/Forgot/index.js